import { useCallback, useState } from 'react';

import {
  fetchWorksFromFirebase,
  fetchFeturedWorksFromFirebase,
} from '../../services/works.services';
import { fetchJobsFromFirebase } from '../../services/jobs.services';
import { JobUrls, loadStates, MailUrls, WorkUrls } from '../utils/api.utils';
import { addMailToFirebase } from '../../services/mails.services';

export const useApi = ({ url, loadState = null }) => {
  const [state, setState] = useState({
    data: undefined,
    loadState,
    error: undefined,
  });

  const callApi = useCallback(
    async (params) => {
      setState((prevState) => ({
        ...prevState,
        loadState: loadStates.loading,
      }));

      const process = (response) => {
        try {
          setState((prevState) => ({
            ...prevState,
            loadState: loadStates.success,
            data: response.data,
          }));
        } catch (error) {
          setState((prevState) => ({
            ...prevState,
            loadState: loadStates.error,
            error: response.error,
          }));
        }
      };

      switch (url) {
        case WorkUrls.getFeaturedWorks:
          return fetchFeturedWorksFromFirebase().then(process);
        case WorkUrls.getWorks:
          return fetchWorksFromFirebase().then(process);
        case JobUrls.getJobs:
          return fetchJobsFromFirebase().then(process);
        case MailUrls.addMail:
          return addMailToFirebase(params).then(process);
        default:
          setState((prevState) => ({
            ...prevState,
            error: 'no such url',
            loadState: loadStates.error,
          }));
          return;
      }
    },
    [url]
  );

  return [callApi, state.loadState, state.data, state.error];
};
